import React, { type FC } from 'react';
import cn from 'classnames';

import type { IPackageBlockItem } from '../../types';
import { PACKAGE_INFO_ITEM_TEST_ID } from '../../constants';
import styles from './packageInfoItem.module.css';

const PackageBlockItem: FC<IPackageBlockItem> = ({
  icon = null,
  className,
  children = null,
  onClickRoomImage,
  packageId = 0,
}) => (
  <div
    className={cn(styles.container, className)}
    data-testid={PACKAGE_INFO_ITEM_TEST_ID}
  >
    {icon && (
      <button
        className={styles.iconButton}
        type="button"
        onClick={() => onClickRoomImage?.(packageId)}
      >
        {icon}
      </button>
    )}
    <div className={styles.content}>{children}</div>
  </div>
);

export default PackageBlockItem;
